import React, { useState } from "react";
import "./Reviews.css"; // Import the CSS file

const ReviewsPage = () => {
  const [reviews, setReviews] = useState([
    { id: 1, name: "ShreeRam", review: "Great service and reliable cars!😎, And All Car Services and Maintanance time to time with Services Record💯", rating: 5 },
    { id: 2, name: "ShreeShyam", review: "Affordable prices and Best Mafia Cars Provide this site.", rating: 4 },
    { id: 3, name: "Ankit Kumawat", review: "Affordable prices and friendly staff😎💯.", rating: 5 },
  ]);

  const [newReview, setNewReview] = useState({ name: "", review: "", rating: "" });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewReview({ ...newReview, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newReview.name && newReview.review && newReview.rating) {
      setReviews([...reviews, { ...newReview, id: reviews.length + 1 }]);
      setNewReview({ name: "", review: "", rating: "" });
    }
  };

  return (
    <div className="reviews-container">
      <h1 className="reviews-heading">Customer Reviews</h1>

      <div className="reviews-list">
        {reviews.map((review) => (
          <div key={review.id} className="review-card">
            <h3 className="review-name">{review.name}</h3>
            <p className="review-text">{review.review}</p>
            <p className="review-rating">Rating: {review.rating} / 5</p>
          </div>
        ))}
      </div>

      <div className="review-form-container">
        <h2 className="form-heading">Add Your Review</h2>
        <form onSubmit={handleSubmit} className="review-form">
          <input
            type="text"
            name="name"
            value={newReview.name}
            onChange={handleChange}
            placeholder="Your Name"
            className="form-input"
            required
          />
          <textarea
            name="review"
            value={newReview.review}
            onChange={handleChange}
            placeholder="Your Review"
            className="form-textarea"
            required
          />
          <select
            name="rating"
            value={newReview.rating}
            onChange={handleChange}
            className="form-select"
            required
          >
            <option value="">Select Rating</option>
            <option value="1">1 - Poor</option>
            <option value="2">2 - Fair</option>
            <option value="3">3 - Good</option>
            <option value="4">4 - Very Good</option>
            <option value="5">5 - Excellent</option>
          </select>
          <button type="submit" className="form-button">
            Submit Review
          </button>
        </form>
      </div>
    </div>
  );
};

export default ReviewsPage;
